export default {
  state: {
    swiper: {}
  },
  mutations: {
    updateSwiper(state, payload) {
      state.swiper = payload;
    }
  }
};
